module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-Doma-Auto-Driver.28323055.gif";